import React, { useEffect } from 'react';

// Utils
import { MESSAGES } from '~/utils/message.js';
import OlcButton from '~/components/General/OlcButton';

//MUI Component
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress, DialogTitle } from '@mui/material';

// Icons
import { ModalCrossCIcon } from '~/assets/images';

// Styles
import './styles.scss';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ConfirmDialog = ({
  handleClose,
  open,
  message,
  handleOk,
  loading,
  successButtonName,
  header,
  icon,
  className = '',
  modalName = '',
}) => {
  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className={`autoFundModalWrapper ${className}`}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 5,
            top: 5,
            padding: '0',
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <ModalCrossCIcon />
        </IconButton>
        {modalName === 'costBreakdownModal' && (
          <DialogTitle className="costBreakdownHeader">
            <Typography variant="h4">
              {header ? header : MESSAGES.ACCOUNT.WALLET.STRIPE.CONFIRM}
            </Typography>
          </DialogTitle>
        )}
        <DialogContent className="autoFundModalContent">
          <Box className="submitHeader">{icon}</Box>
          {modalName !== 'costBreakdownModal' && (
            <Box className="autoFundHeader">
              <Typography gutterBottom variant="h4">
                {header ? header : MESSAGES.ACCOUNT.WALLET.STRIPE.CONFIRM}
              </Typography>
            </Box>
          )}
          <Box className="amountInputWrapper">
            <Typography>{message}</Typography>
          </Box>
          {modalName === 'costBreakdownModal' ? (
            <></>
          ) : (
            <Box className="autoFundModalBtns">
              <OlcButton variant="secondary" onClick={handleClose}>
                {MESSAGES.ACCOUNT.WALLET.STRIPE.CANCEL}
              </OlcButton>
              <OlcButton variant="primary" disabled={loading} onClick={handleOk}>
                {loading ? (
                  <CircularProgress
                    sx={{
                      color: 'white',
                      width: '25px !important',
                      height: '25px !important',
                    }}
                  />
                ) : successButtonName ? (
                  successButtonName
                ) : (
                  'Ok'
                )}
              </OlcButton>
            </Box>
          )}
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default ConfirmDialog;
